<template>
  <div class="rc-l-public rc-l-public--channels">
    <div class="rc-l-public--title">
      <div class="container">
        <h1 class="mx-auto">{{ $t("statics.channels.title") }}</h1>
      </div>
    </div>
    <!-- section 1 : Text intro -->
    <div class="rc-section">
      <div class="container text-center">
        <div class="row justify-content-center">
          <div class="col-lg-10 rc-col-text">
            <p
              class="mx-auto rc-intro--xl"
              v-html="$t('statics.channels.intro')"
            ></p>
          </div>
        </div>
      </div>
    </div>
    <!-- Channels list -->
    <div>
      <div class="container">
        <div class="rc-list-view">
          <ul>
            <li>
              <article class="row rc-list-unit rc-unit-with-stack">
                <div class="col-md-4">
                  <div class="rc-stack-effect"></div>
                  <div class="rc-thumbnail-wrapper">
                    <img :src="channelImg.first[$i18n.locale]" alt="" />
                  </div>
                </div>
                <div class="col-md-8">
                  <header>
                    <h2 class="h3">
                      <span>{{ $t("statics.channels.channel1.title") }}</span>
                    </h2>
                  </header>
                  <div>
                    <p
                      class="rc-intro"
                      v-html="$t('statics.channels.channel1.text.1')"
                    ></p>
                    <p
                      class="text-secondary"
                      v-html="$t('statics.channels.channel1.text.2')"
                    ></p>
                  </div>
                </div>
              </article>
            </li>
            <li>
              <article class="row rc-list-unit rc-unit-with-stack">
                <div class="col-md-4">
                  <div class="rc-stack-effect"></div>
                  <div class="rc-thumbnail-wrapper">
                    <img :src="channelImg.second[$i18n.locale]" alt="" />
                  </div>
                </div>
                <div class="col-md-8">
                  <header>
                    <h2 class="h3">
                      <span>{{ $t("statics.channels.channel2.title") }}</span>
                    </h2>
                  </header>
                  <div>
                    <p
                      class="rc-intro"
                      v-html="$t('statics.channels.channel2.text.1')"
                    ></p>
                    <p
                      class="text-secondary"
                      v-html="$t('statics.channels.channel2.text.2')"
                    ></p>
                  </div>
                </div>
              </article>
            </li>
            <li>
              <article class="row rc-list-unit rc-unit-with-stack">
                <div class="col-md-4">
                  <div class="rc-stack-effect"></div>
                  <div class="rc-thumbnail-wrapper">
                    <img :src="channelImg.third[$i18n.locale]" alt="" />
                  </div>
                </div>
                <div class="col-md-8">
                  <header>
                    <h2 class="h3">
                      <span>{{ $t("statics.channels.channel3.title") }}</span>
                    </h2>
                  </header>
                  <div class="rc-intro">
                    <p v-html="$t('statics.channels.channel3.text')"></p>
                  </div>
                </div>
              </article>
            </li>
            <li>
              <article class="row rc-list-unit rc-unit-with-stack">
                <div class="col-md-4">
                  <div class="rc-stack-effect"></div>
                  <div class="rc-thumbnail-wrapper">
                    <img :src="channelImg.fourth[$i18n.locale]" alt="" />
                  </div>
                </div>
                <div class="col-md-8">
                  <header>
                    <h2 class="h3">
                      <span>{{ $t("statics.channels.channel4.title") }}</span>
                    </h2>
                  </header>
                  <div class="rc-intro">
                    <p v-html="$t('statics.channels.channel4.text')"></p>
                  </div>
                </div>
              </article>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { navMixin } from "#/routes/mixins";
import channelCurioInfo from "#/assets/img/media/channel_curio_info.jpg";
import channelNewsInReview from "#/assets/img/media/channel_news_in_review.jpg";
import channelBBC from "#/assets/img/media/channel_bbc.jpg";
import channelNationalGeographic from "#/assets/img/media/channel_national_geographic.jpg";

export default {
  name: "RcSiteChannelsPublic",
  mixins: [navMixin],

  computed: {
    channelImg() {
      return {
        first: { en: channelNewsInReview, fr: channelCurioInfo },

        second: { en: channelCurioInfo, fr: channelNewsInReview },

        third: { en: channelBBC, fr: channelBBC },

        fourth: { en: channelNationalGeographic, fr: channelNationalGeographic }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-list-view {
  h2 {
    margin-bottom: 0.5rem;
  }
  ul li:last-child {
    border-bottom: 0;
  }
}
</style>
